import { ObservationsParams } from './types'

type ObservationsQueryParams = Partial<{
  product: number
  training: number
  trainingTest: number
  availableForTesting: number
  annotationClasses: string
  productClasses: string
  dataset: string
  dataset_exclude: boolean
  filename: string
}>

export const getObservationsQueryParams = (
  params: ObservationsParams
): ObservationsQueryParams => ({
  product: params.productId,
  training: params.trainingId,
  trainingTest: params.trainingTestId,
  availableForTesting: params.availableForTesting,
  annotationClasses: params.annotationClasses,
  productClasses:
    params.productClasses && params.productClasses.length
      ? params.productClasses.join()
      : undefined,
  dataset:
    params.dataset && params.dataset.length ? params.dataset.join() : undefined,
  dataset_exclude: params.datasetExclude,
  filename: params.filename,
})
